import { Divider, IconButton, Paper } from "@mui/material";
import React, { useContext } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { ClearRounded } from "@mui/icons-material";
import moment from "moment";
import { CartContext } from "../POS";

const Payments = () => {
  dayjs.extend(customParseFormat);
  const { cartData, setCartData } = useContext(CartContext);

  const handleDelete = (key) => {
    setCartData((j) => ({
      ...j,
      payments: [...j.payments.filter((x) => x.key !== key)],
    }));
  };

  return cartData && cartData.payments.length > 0 ? (
    <Paper className="grid gap-1 border-slate-300 border-1 pb-[10px] mt-[20px]">
      {/* Header */}
      <div className="flex justify-between p-[10px] pb-[5px]">
        <span className="text-[18px] uppercase text-gray-500 font-semibold ml-5">
          Total Received: $
          {cartData.received.toLocaleString("en-US", {
            maximumFractionDigits: 2,
          })}
        </span>
        <span className="text-[18px] uppercase text-gray-500 font-semibold mr-5">
          To Pay: ${" "}
          {Math.max(0, cartData.netPayable - cartData.received).toLocaleString(
            "en-US",
            {
              maximumFractionDigits: 2,
            }
          )}
        </span>
      </div>

      {/* Body */}
      <div className="flex flex-col gap-1">
        <Divider />
        {cartData.payments.map((p, index) => (
          <div
            key={index}
            className={`flex items-center justify-between pl-[15px] pr-[15px] ${
              index + 1 >= cartData.payments.length ? "" : " pb-[5px] border-b"
            }`}
          >
            <div className="flex gap-2 items-center">
              {p.newPayment && (
                <IconButton
                  onClick={() => handleDelete(p.key)}
                  color="error"
                  size="small"
                >
                  <ClearRounded className="!text-[18px]" />
                </IconButton>
              )}

              <div className="flex flex-col">
                <span className="font-medium text-gray-600">{p.name}</span>
                <span className="text-[12px] font-medium">
                  {moment(new Date(p.createDate)).format(
                    "ddd, MMM D, YYYY, h:mm A"
                  )}
                </span>
              </div>
            </div>

            <span className="text-[20px] font-semibold text-gray-600">
              ${" "}
              {(p.amount || 0).toLocaleString("en-US", {
                maximumFractionDigits: 2,
              })}
            </span>
          </div>
        ))}
      </div>
    </Paper>
  ) : null;
};

export default Payments;
